import { INITIAL_STATE } from '../reducers/is-app-loaded';

export const getIsAppLoaded = (state) => state.isAppLoaded || INITIAL_STATE;
